import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Database } from "@/integrations/supabase/types";
import { getUrlParam } from "@/utils/urlUtils";

export type Clinic = Database["public"]["Tables"]["clinics"]["Row"];

export const useClinics = () => {
  // ?internal=true (staff mode) also reveals inactive clinics; public flow sees active only.
  const isInternal = getUrlParam("internal") === "true";
  return useQuery({
    queryKey: ["clinics", isInternal],
    queryFn: async () => {
      let query = supabase.from("clinics").select("*, clinic_closed_times(*)");

      if (!isInternal) {
        query = query.eq("status", "active");
      }

      const { data, error } = await query
        .order("sort_order", { ascending: true })
        .order("name", { ascending: true });

      if (error) {
        throw error;
      }

      return data as any as (Clinic & { clinic_closed_times: Array<any> })[];
    },
    staleTime: 1000 * 60 * 30, // Cache for 30 minutes
  });
};
